module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"report_button":"檢舉不當留言"}}')
  delete Component.options._Ctor
}
